<template>
  <div>
    <header-component />
    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Vendor Type List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button size="sm" type="primary" @click="createVendorType">Add New</base-button>
          </div>
        </div>
        <el-table
          :data="vendorTypeList"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column label="Name" prop="label" />
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
                <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown" class="dropdown-menu dropdown-menu-arrow show" >
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog :visible.sync="addVendorType" title="Add Vendor Type">
        <add-vendorType @close="addVendorType = false" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddVendorType from "./AddVendorType";
import headerComponent from "../Components/HeaderComponent";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "add-vendorType": AddVendorType,
    "header-component": headerComponent
  },
  data: () => {
    return {
      addVendorType: false
    };
  },

  computed: {
    ...mapGetters({
      vendorType: "vendorType/getVendorType",
      vendorTypeList: "vendorType/getVendorTypeList"
    })
  },

  mounted() {
    this.getVendorTypeList();
  },

  methods: {
    ...mapActions({
      getVendorTypeList: "vendorType/getVendorTypeList",
      fetchVendorType: "vendorType/fetchVendorType"
    }),
    ...mapMutations({
      setVendorType: "vendorType/setVendorType",
      resetVendorType: "vendorType/resetVendorType"
    }),
    handleAction(vendorType, command) {
      if (command === "edit") {
        this.fetchVendorType(vendorType.vendorTypeId).then(res => {
          this.addVendorType = true;
          this.setVendorType(res);
        });
      }
    },

    createVendorType() {
      this.resetVendorType();
      this.addVendorType = true;
    }
  }
};
</script>